module.exports = __webpack_public_path__ + "img/pickup_ng.06d72339.png";